/* Barrio Kit · portada (06-10-2026)
   - revelado de bloques al hacer scroll
   - hero: carrusel 3D de plantillas que gira segun bajas (y un poco con el raton), con capas parallax
   Sin dependencias. Si algo falla, la pagina sigue siendo usable. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var onScroll = function (fn) { document.addEventListener('scroll', fn, { capture: true, passive: true }); };

  function reveal() {
    var els = document.querySelectorAll('[data-bk-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (e) { io.observe(e); });
  }

  function hero() {
    var h = document.querySelector('[data-bk-hero]');
    if (!h) return;
    var ring = h.querySelector('[data-bk-ring]');
    var sticky = h.querySelector('.bkh__sticky');
    var layers = Array.prototype.slice.call(h.querySelectorAll('[data-depth]'));
    if (!ring || !sticky) return;
    var turns = parseFloat(h.getAttribute('data-turns')) || 1;
    var angle = 0, drift = 0, mx = 0, my = 0, tx = 0, ty = 0, raf = null, vis = true, last = 0, scrolled = false;

    function progress() {
      var r = h.getBoundingClientRect();
      var travel = r.height - sticky.offsetHeight;
      if (travel <= 0) return 0;
      var p = -r.top / travel;
      return Math.max(0, Math.min(1, p));
    }
    function paint(now) {
      raf = null;
      var p = progress();
      if (!reduce && now && last) drift += (now - last) * 0.004; /* giro lento de fondo, ~4 grados/segundo */
      last = now || 0;
      mx += (tx - mx) * 0.08; my += (ty - my) * 0.08;
      angle = -p * 360 * turns + (reduce ? 0 : drift) + mx * 14;
      ring.style.transform = 'rotateX(' + (-8 + my * 5).toFixed(2) + 'deg) rotateY(' + angle.toFixed(2) + 'deg)';
      layers.forEach(function (l) {
        var d = parseFloat(l.getAttribute('data-depth')) || 0;
        l.style.transform = 'translate3d(' + (mx * 30 * d).toFixed(1) + 'px,' + (p * -220 * d + my * 20 * d).toFixed(1) + 'px,0)';
      });
      if (p > 0.04 && !scrolled) { scrolled = true; h.classList.add('is-scrolled'); }
      if (vis && !reduce) raf = requestAnimationFrame(paint);
    }
    function ask() { if (!raf) raf = requestAnimationFrame(paint); }
    onScroll(ask);
    if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      h.addEventListener('mousemove', function (e) {
        var r = sticky.getBoundingClientRect();
        tx = ((e.clientX - r.left) / r.width - 0.5) * 2;
        ty = ((e.clientY - r.top) / r.height - 0.5) * 2;
        ask();
      });
      h.addEventListener('mouseleave', function () { tx = 0; ty = 0; ask(); });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { vis = en[0].isIntersecting; last = 0; if (vis) ask(); }).observe(h);
    }
    ask();
  }

  function init() { reveal(); hero(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* editor de temas: cuando Shopify vuelve a pintar una seccion, se reengancha todo */
  document.addEventListener('shopify:section:load', init);
})();
